import 'rxjs';
import { fromJS } from 'immutable';

//Action types
const FETCH_PRODUCTS_REQUEST = 'PRODUCTS/FETCH_PRODUCTS_REQUEST';
const FETCH_PRODUCTS_SUCCESS = 'PRODUCTS/FETCH_PRODUCTS_SUCCESS';
const FETCH_PRODUCTS_ERROR = 'PRODUCTS/FETCH_PRODUCTS_ERROR';
const CONFIGURE_VARIATION_DETAILS = 'PRODUCTS/CONFIGURE_VARIATION_DETAILS';

//Action creators
export const fetchProductsRequest = () => ({ type: FETCH_PRODUCTS_REQUEST });
export const fetchProductsSuccess = (products) => ({ type: FETCH_PRODUCTS_SUCCESS, products });
// const fetchProductsError = (error) => ({ type: FETCH_PRODUCTS_ERROR, error });

export const configureVariationDetails = (productId, variationId) => ({ ype: CONFIGURE_VARIATION_DETAILS, productId, variationId });

// epic
export const fetchProductsEpic = (action$, store, {getProducts}) =>
    action$.ofType(FETCH_PRODUCTS_REQUEST)
        .mergeMap(action =>
            getProducts()
                .map(response => fetchProductsSuccess(response))
        );

//initial state for this reducer
const initialState = fromJS({
    products: [],
    isLoading: false,
    //error: '' 
});

//Reducer
export default function reducer(state = initialState, action) {
    switch (action.type) {
        case FETCH_PRODUCTS_REQUEST:
            return state.set('isLoading', true);
        //return ({ ...state, isLoading: true });
        case FETCH_PRODUCTS_SUCCESS:
            return state.set('isLoading', false).set('products', fromJS(action.products));//podríamos usar: fromJS(action.products)
        //return ({ ...state, products: action.products, isLoading: false });
        case FETCH_PRODUCTS_ERROR:
            return state.set('isLoading', false).set('error', action.error);
        //return ({ ...state, error: action.error, isLoading: false });
        case CONFIGURE_VARIATION_DETAILS:
            let newOrder = state.get('order');
            newOrder.set('productId', action.productId);
            newOrder.set('variationId', action.variationId);
            return state.set('order', newOrder);
        //return ({ ...state, order: { ...state.order, productId: action.productId, variationId: action.variationId } });

        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/redux/modules/productsDuck.js